import { PROJECT_TYPE, type ProjectType } from './const';

export const isWtmProjectType = (type: ProjectType): boolean => {
  const list: ProjectType[] = [PROJECT_TYPE.wtmHomePage, PROJECT_TYPE.continuousOptimization];
  return list.includes(type);
};

export const isBlogPostProjectType = (type: ProjectType): boolean =>
  type === PROJECT_TYPE.blogPostBuilder;

export const isLongFormProjectType = (type: ProjectType): boolean =>
  type === PROJECT_TYPE.longFormBuilder;

export const isDocumentProjectType = (type: ProjectType): boolean => {
  if (!type) {
    return false;
  }

  return !isWtmProjectType(type) && !isBlogPostProjectType(type) && !isLongFormProjectType(type);
};
